import classNames from 'classnames'
import React from 'react'

import { Currency } from '../../../backend'
import { useSelectedCurrency } from '../../hooks/useSelectedCurrency'

import { SelectorOption, Selector } from './Selector'

const currencySymbols: Record<Currency, string> = {
  EUR: '€',
  GBP: '£',
  USD: '$',
}

interface Props {
  heading?: string
  onSelect?(): void
}

export const CurrencySelector = ({ heading, onSelect }: Props) => {
  const { currency: selectedCurrency, setCurrency } = useSelectedCurrency()
  return (
    <Selector heading={heading}>
      {Currency.options.map(currency => (
        <SelectorOption
          className={classNames(
            currency === selectedCurrency && 'selector__option--selected',
          )}
          key={currency}
          onClick={() => {
            setCurrency(currency)
            onSelect?.()
          }}
        >
          {currency} {currencySymbols[currency]}
        </SelectorOption>
      ))}
    </Selector>
  )
}
